import type { SeverityLevel } from '@sentry/vue';

export enum SentryServiceName {
  PAYMENT = 'PAYMENT_SERVICE',
  AUTH = 'AUTH',
  ACCOUNT = 'ACCOUNT_SERVICE',
  RULE_ENGINE = 'RULE_ENGINE_SERVICE',
  ACCESS_CONTROL = 'ACCESS_CONTROL_SERVICE',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE_SERVICE',
  IMPORT_PAYMENT = 'IMPORT_PAYMENT_SERVICE',
  STATEMENT = 'STATEMENT_SERVICE',
  NOTIFICATION = 'NOTIFICATION_SERVICE',
  LETTER_BANK = 'LETTER_BANK_SERVICE',
  CARD_SALARY = 'CARD_SALARY_SERVICE',
  FAQ = 'FAQ_SERVICE',
  INSTALLMENT = 'INSTALLMENT_SERVICE',
  PAY_LOGIC = 'PAY_LOGIC_SERVICE',
  MANY_SERVICE = 'MANY_SERVICE',
  SALE_POINT = 'SALE_POINT_SERVICE',
  O24_ACCOUNT = 'O24_ACCOUNT_SERVICE',
  O24_INVOICE = 'O24_INVOICE_SERVICE',
  ACTION_LIMIT = 'ACTION_LIMIT_SERVICE',
  RUTOKEN = 'RUTOKEN',
}

export enum SentryLevel {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  FATAL = 'fatal',
}

export interface SentryUserContext {
  id?: string;
  username?: string;
}

export interface SentryOrganizationContext {
  org_reference_id?: string | number;
  company_name?: string;
  sign_type?: string;
  sign_scheme?: string;
  sign_right?: string;
}

export interface SentryAuthStoreLike {
  userId?: unknown;
  user?: {
    fullName?: string;
  };
  selectedUserContract?: unknown;
}

export interface SentryAuthContext {
  user?: SentryUserContext;
  organization?: SentryOrganizationContext;
}

export interface SentryPayload extends SentryAuthContext {
  service: SentryServiceName | string;
  payload?: unknown;
  error: unknown;
  level?: SeverityLevel;
  typeAction?: string;
  graphqlField?: string;
  xTraceId?: string;
  headerClassification?: string;
  statusCode?: number;
}

export interface BrowserConnectionInfo {
  downlink?: number;
  effectiveType?: string;
  rtt?: number;
  saveData?: boolean;
}

export interface NormalizedError {
  source: 'graphql' | 'network' | 'exception' | 'message' | 'unknown';
  message: string;
  classification?: string;
  code?: string;
  path?: string;
  statusCode?: number;
  name?: string;
  stack?: string;
}

export type UnknownRecord = Record<string, unknown>;
